export const CHART_COLORS = {
    blue: "#1CAFFF",
    teal: "#56E2C0",
    violet: "#8A56E2",
    lime: "#AEE256",
    pink: "#E255AE",
    orange: "#E28956",
    green: "#44DE91",
    coral: "#E25668",
    gold: "#FFDA44",
    grid: "rgba(255,255,255,0.07)",
    axis: "#64748B",
    axisStrong: "#94A3B8",
    track: "rgba(255,255,255,0.06)",
} as const;
